(function () {
  'use strict';

  /****************************************************************
   * 1. CONFIGURATION
   ****************************************************************/
  const SOLID_COLORS = ['Black', 'Golden', 'Silver'];
  
  // Your exact filenames
  const COLOR_KEYWORDS = {
    'Black': ['_black_unframed', 'black_unframed'],
    'Golden': ['_golden_unframed', 'golden_unframed', '_beige_unframed', 'beige_unframed'],
    'Silver': ['_silver_unframed', 'silver_unframed', '_white_unframed', 'white_unframed'],
    'Golden & White': ['golden_white_framed', 'golden_and_white_framed', 'goldenwhite_framed'],
    'Black & Diar': ['black_diar_framed', 'black_and_diar_framed', 'blackdiar_framed'],
    'Black & White': ['black_white_framed', 'black_and_white_framed', 'blackwhite_framed'],
    'Silver & Black': ['silver_black_framed', 'silver_and_black_framed', 'silverblack_framed'],
    'Golden & Black': ['golden_black_framed', 'golden_and_black_framed', 'goldenblack_framed']
  };

  /****************************************************************
   * 2. CSS INJECTION (Safe Mode)
   ****************************************************************/
  const style = document.createElement('style');
  style.innerHTML = `
    /* Use specific classes to hide options without breaking layout */
    body.daud-framed .daud-solid-opt { display: none !important; }
    body.daud-unframed .daud-complex-opt { display: none !important; }
  `;
  document.head.appendChild(style);

  /****************************************************************
   * 3. STATE MANAGEMENT (No Loops)
   ****************************************************************/
  let isProcessing = false; // The Safety Lock

  function updateUI() {
    if (isProcessing) return; // Prevent infinite loops
    isProcessing = true;

    try {
      // 1. Identify Mode
      const frameInput = document.querySelector('input[name*="Frame"]:checked, input[name*="Style"]:checked');
      const mode = (frameInput && frameInput.value.toLowerCase().includes('framed') && !frameInput.value.toLowerCase().includes('unframed')) 
                   ? 'framed' 
                   : 'unframed';

      // 2. Classify Buttons (Tag them for CSS)
      const allInputs = document.querySelectorAll('input[name*="Color"], input[name*="color"]');
      allInputs.forEach(input => {
        const label = input.closest('label') || document.querySelector(`label[for="${input.id}"]`);
        if (!label) return;

        const isSolid = SOLID_COLORS.includes(input.value);
        if (isSolid) {
          label.classList.add('daud-solid-opt');
          label.classList.remove('daud-complex-opt');
        } else {
          label.classList.add('daud-complex-opt');
          label.classList.remove('daud-solid-opt');
        }
      });

      // 3. Update Body Class (Triggers Hiding)
      if (mode === 'framed') {
        document.body.classList.add('daud-framed');
        document.body.classList.remove('daud-unframed');
      } else {
        document.body.classList.add('daud-unframed');
        document.body.classList.remove('daud-framed');
      }

      // 4. Auto-Switch if on Hidden Option
      const currentChecked = document.querySelector('input[name*="Color"]:checked, input[name*="color"]:checked');
      if (currentChecked) {
        const isSolid = SOLID_COLORS.includes(currentChecked.value);
        let needsSwitch = false;

        if (mode === 'framed' && isSolid) needsSwitch = true;
        if (mode === 'unframed' && !isSolid) needsSwitch = true;

        if (needsSwitch) {
          // Find first valid option
          for (let input of allInputs) {
            const inputIsSolid = SOLID_COLORS.includes(input.value);
            let isValid = (mode === 'framed' && !inputIsSolid) || (mode === 'unframed' && inputIsSolid);
            
            if (isValid) {
              input.checked = true;
              // Dispatch change to notify Shopify, but keep lock on to prevent loop
              input.dispatchEvent(new Event('change', { bubbles: true }));
              break;
            }
          }
        }
      }

      // 5. Filter Images (Lightweight)
      filterImages();

    } finally {
      // Release the lock
      setTimeout(() => { isProcessing = false; }, 50);
    }
  }

  function filterImages() {
    const checked = document.querySelector('input[name*="Color"]:checked, input[name*="color"]:checked');
    if (!checked) return;

    const keywords = COLOR_KEYWORDS[checked.value] || [];
    if (keywords.length === 0) return;

    const images = document.querySelectorAll('.product__media-item, .product__media-list li, [id*="Slide-"]');
    
    // Batch DOM writes for performance
    requestAnimationFrame(() => {
      images.forEach(imgContainer => {
        const img = imgContainer.querySelector('img');
        if (!img) return;
        
        const src = img.src.toLowerCase();
        const match = keywords.some(k => src.includes(k.toLowerCase()));
        imgContainer.style.display = match ? 'block' : 'none';
      });

      // Fix Dawn Slider
      const slider = document.querySelector('slider-component');
      if (slider && slider.resetPages) slider.resetPages();
    });
  }

  /****************************************************************
   * 4. INIT
   ****************************************************************/
  function init() {
    updateUI();

    document.addEventListener('change', (e) => {
      if (e.target.matches('input[type="radio"]')) {
        updateUI();
      }
    });

    // SAFE OBSERVER: Only watches for added nodes, ignores attributes
    const observer = new MutationObserver((mutations) => {
      // Only react if nodes were actually added (Shopify re-render)
      const nodesAdded = mutations.some(m => m.addedNodes.length > 0);
      if (nodesAdded && !isProcessing) {
        updateUI();
      }
    });

    const target = document.querySelector('.product-form') || document.body;
    observer.observe(target, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();